import React, { useState } from 'react';
import PitchDetectorComponent from './components/PitchDetectorComponent';
import ViolinFingerPositionDiagram from './components/ViolinFingerPositionDiagram';
import './App.css';

function App() {
  const [detectedPitch, setDetectedPitch] = useState(null);

  const majorScalesToHighlight = ['G', 'A', 'D', 'C', 'F'];
  const minorScalesToHighlight = ['A', 'E'];
  const rootNotes = ['C', 'G', 'D', 'A', 'E', 'B', 'F#', 'C#', 'G#', 'D#', 'A#', 'F'];

  return (
    <div className="App">
      <PitchDetectorComponent onPitchDetected={setDetectedPitch} visible={false} />

      {/* Major Scales Section */}
      <section className="my-8">
        <h2 className="text-3xl text-blue-400 font-semibold">Major Scales</h2>
        <div className="center-grid">
          <div className="grid grid-cols-6 gap-4">
            {rootNotes.map(note => (
                <ViolinFingerPositionDiagram
                  key={note + "Major"}
                  scale={0.75}
                  scaleType="Major"
                  rootNote={note}
                  highlight={majorScalesToHighlight.includes(note)}
                  detectedPitch={detectedPitch}
                  />
            ))}
          </div>
        </div>
      </section>

      {/* Minor Scales Section */}
      <section className="my-8">
        <h2 className="text-3xl text-blue-400 font-semibold">Minor Scales</h2>
        <div className="center-grid">
          <div className="grid grid-cols-6 gap-4">
            {rootNotes.map(note => (
                <ViolinFingerPositionDiagram
                  key={note + "Minor"}
                  scale={0.75}
                  scaleType="Minor"
                  rootNote={note}
                  highlight={minorScalesToHighlight.includes(note)}
                  detectedPitch={detectedPitch}
                  />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
